import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { COMMUNITY_ID_KEY } from '@/utility/constants';
import CookieService from '@/utility/cookieService';
import { defaultLocale } from '@/utility/localization/constants';
import { getQueryParams } from '@/utility/urlHelpers';

import { useAuthContext } from '@/contexts/AuthContext';

import PortalPagesMetaTags from '@/components/common/PortalPagesMetaTags';

import useLocale from '@/hooks/useLocale';

const PrivateContainer = ({ children }) => {
  const { isLoggedIn, hasToken, isIntentionalLogout } = useAuthContext();
  const { currentLocale } = useLocale();
  const router = useRouter();

  useEffect(() => {
    // Only check for auth if there is no token and refresh token on url params
    if (!router.isReady) return;

    const { activeCommunityId } = getQueryParams();
    if (activeCommunityId) {
      CookieService.set(COMMUNITY_ID_KEY, activeCommunityId);
    }

    if (!isLoggedIn && !hasToken && !isIntentionalLogout) {
      const routerAsPath = window.location.pathname;
      const loginRoute =
        currentLocale === defaultLocale
          ? '/login'
          : `/${currentLocale}/login`;
      window.location.href = `${loginRoute}?redirectTo=${routerAsPath}`;
    }
  }, [isLoggedIn, hasToken]);

  return (
    <>
      <PortalPagesMetaTags />
      {children}
    </>
  );
};

export default PrivateContainer;
